import React, { useState, useEffect } from 'react';
import Joyride, { CallBackProps, STATUS, Step } from 'react-joyride';
import { HelpCircle } from 'lucide-react';
import { __ } from './translations';

const TOUR_KEY = 'has_seen_tour';

const AppTour = () => {
  const [run, setRun] = useState(false);

  useEffect(() => {
    // Check if this is the first visit
    const hasSeenTour = localStorage.getItem(TOUR_KEY);
    
    if (!hasSeenTour) {
      // Start the tour automatically after a short delay
      // to ensure all components are rendered
      const timer = setTimeout(() => {
        setRun(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, []);

  const steps: Step[] = [
    {
      target: '.container',
      content: __('Welcome to the Board Member Portal! This guided tour will help you get started.'),
      placement: 'center',
      disableBeacon: true
    },
    {
      target: 'nav button:nth-child(1)',
      content: __('In the Company section, you can view and edit your company details, manage users, and access important documents.'),
      placement: 'bottom'
    },
    {
      target: 'nav button:nth-child(2)',
      content: __('The Annual Data section is where you manage your contributions: • Select the contribution year • Enter your company\'s income • Review the calculated contribution • Accept and submit your contribution'),
      placement: 'bottom'
    },
    {
      target: 'nav button:nth-child(3)',
      content: __('Access information about General Meetings of Members, including schedules and documents.'),
      placement: 'bottom'
    },
    {
      target: 'nav button:nth-child(4)',
      content: __('View important announcements and critical updates.'),
      placement: 'bottom'
    },
    {
      target: 'nav button:nth-child(5)',
      content: __('Stay updated with the latest news and announcements in the Member Posts section.'),
      placement: 'bottom'
    },
    {
      target: 'nav button:nth-child(6)',
      content: __('Access research papers, analyses, and industry studies.'),
      placement: 'bottom'
    },
    {
      target: 'nav button:nth-child(7)',
      content: __('Explore our knowledge base for helpful resources and documentation.'),
      placement: 'bottom'
    },
    {
      target: 'nav button:nth-child(8)',
      content: __('Keep track of upcoming events and important dates.'),
      placement: 'bottom'
    }
  ];

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      localStorage.setItem(TOUR_KEY, 'true');
      setRun(false);
    }
  };

  return (
    <>
      <Joyride
        steps={steps}
        run={run}
        continuous
        showProgress
        showSkipButton
        callback={handleJoyrideCallback}
        styles={{
          options: {
            primaryColor: '#2563eb',
            textColor: '#111827',
            backgroundColor: '#ffffff',
            arrowColor: '#ffffff',
            overlayColor: 'rgba(0, 0, 0, 0.5)'
          },
          tooltip: {
            padding: '1rem',
            borderRadius: '0.5rem',
            fontSize: '0.875rem',
            maxWidth: '20rem'
          },
          buttonBack: {
            marginRight: '0.5rem'
          }
        }}
        locale={{
          back: __('Back'),
          close: __('Close'),
          last: __('Finish'),
          next: __('Next'),
          nextLabelWithProgress: __('Next (Step {step} of {steps})'),
          open: __('Open the dialog'),
          skip: __('Skip')
        }}
      />
      <button
        onClick={() => setRun(true)}
        className="fixed bottom-4 right-4 bg-blue-600 text-white rounded-full p-2 hover:bg-blue-700 shadow-lg flex items-center gap-2 z-50"
        title={__('Take a guided tour')}
      >
        <HelpCircle className="h-6 w-6" />
        <span className="mr-2">{__('Take a Tour')}</span>
      </button>
    </>
  );
};

export default AppTour;